import axios from 'axios';
import React, { useEffect, useState } from 'react';
import SweetAlert from 'react-bootstrap-sweetalert';
import ReactGA from 'react-ga';
import { NotificationContainer, NotificationManager } from 'react-notifications';
import { useDispatch } from 'react-redux';
import VoucherFinalPurchase from '../../containers/includes/VoucherFinalPurchase';
import VoucherPopup from '../../containers/includes/VoucherPopup';
import VoucherModals from '../LandingComponent/VoucherModals';
import Search from '../Search/SearchNew';

import moment from 'moment';
import publicIp from 'public-ip';
import { trackEventSource, trackEventSourceNoAuth } from '../../Utils/EventSourcing';

const LandingBannerNew = ({ smallBanner, disableBackground, userNameProps, secondaryStyle }) => {
  const dispatch = useDispatch();
  const [alert, setAlert] = useState('');
  const [voucherModalOpen, setVoucherModalOpen] = useState(false);
  const [voucherFinalSubmitModalOpen, setVoucherFinalSubmitModalOpen] = useState(false);
  const [voucher_code, setVoucher_code] = useState('');
  const [voucher_code_referral, setVoucher_code_referral] = useState('');
  const [voucherModalNewOpen, setVoucherModalNewOpen] = useState(false);
  const [voucherModalNewIsSuccess, setVoucherModalNewIsSuccess] = useState(false);
  const [voucherModalNewMsgId, setVoucherModalNewMsgId] = useState(null);
  const [voucherModalNewMsgOtherEmail, setVoucherModalNewMsgOtherEmail] = useState(null);
  const [voucherModalNewTitle, setVoucherModalNewTitle] = useState(null);

  useEffect(() => {
    const _voucher_code = localStorage.getItem('voucher_code');
    const _voucher_code_register = localStorage.getItem('voucher_register');
    if (_voucher_code && !_voucher_code_register) {
      checkValidVoucher(_voucher_code);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const toggleModalVoucherPurchasePage = () =>
    setVoucherFinalSubmitModalOpen(!voucherFinalSubmitModalOpen);

  const toggleModalVoucherPage = () => setVoucherModalOpen(!voucherModalOpen);

  const toggleFinalSubmitPage = (voucher_code) => {
    setVoucherFinalSubmitModalOpen(!voucherFinalSubmitModalOpen);
    setVoucher_code(voucher_code);
    setVoucher_code_referral(voucher_code);
  };

  const checkValidVoucher = (voucher) => {
    dispatch({ type: 'TOGGLE_LOADING_TRUE' });
    const access_token = localStorage.getItem('access_token');

    axios
      .get(`${window.$API_URL}api/voucher/checkvoucher/?voucher_code=${voucher}`, {
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${access_token}` },
      })
      .then(async (success) => {
        dispatch({ type: 'TOGGLE_LOADING_FALSE' });

        if (success.data.success && !success.data.data.is_purchased) {
          //public
          // localStorage.setItem('voucher_code', voucher);
          dispatch({ type: 'STORE_VOUCHER_CODE', payload: voucher });
          setVoucherModalNewOpen(true);
          setVoucherModalNewIsSuccess(true);
          setVoucherModalNewMsgId('success-public');
          setVoucherModalNewTitle('Voucher Tersedia!');
        } else if (success.data.success && success.data.data.is_purchased) {
          trackEventSource({
            type: 'courseregister',
            payload: {
              course_id: success.data.data.course.id,
              method: 'voucher',
              code: voucher,
              voucher_id: success.data.data.id,
              mpp_id: success.data.data.mpp ? success.data.data.mpp.id : '',
            },
          });
          trackEventSourceNoAuth({
            type: 'courseregisterip',
            payload: {
              ip: await publicIp.v4(),
              course_id: success.data.data.course.id,
              date: moment().format('YYYY-MM-DD hh:mm:ss'),
            },
          });
          ReactGA.event({
            category: 'Kelas Populer',
            action: 'Redeem-Voucher',
            label: `Kode Voucher in Homepage`,
          });
          if (success.data.data.is_external) {
            const getAlert = () => (
              <SweetAlert
                success
                showCancel={false}
                confirmBtnText="Click Here"
                confirmBtnBsStyle="success"
                title="Voucher Berhasil Ditebus!"
                onConfirm={(e) => (window.location.href = success.data.data.external_url)}
              >
                Selamat! Voucher Anda telah berhasil ditebus. Untuk mengakses Pelatihan, Silakan
                kunjungi Situs Mitra Kami.
              </SweetAlert>
            );
            setAlert(getAlert());
          } else {
            setVoucherModalNewOpen(true);
            setVoucherModalNewIsSuccess(true);
            setVoucherModalNewMsgId('success-login');
            setVoucherModalNewTitle('Voucher Berhasil digunakan!');
          }
        }
      })
      .catch((error) => {
        dispatch({ type: 'TOGGLE_LOADING_FALSE' });
        if (error.response) {
          if (error.response.status === '404') {
            if (error.response.data.message === 'Kode voucher ini sudah digunakan sebelumnya') {
              setVoucherModalNewOpen(true);
              setVoucherModalNewIsSuccess(false);
              setVoucherModalNewMsgId('already-used');
              setVoucherModalNewTitle('Voucher Sudah digunakan!');
            } else if (error.response.data.message === 'Voucher Tidak Ditemukan') {
              setVoucherModalNewOpen(true);
              setVoucherModalNewIsSuccess(false);
              setVoucherModalNewMsgId('not-found');
              setVoucherModalNewTitle('Voucher tidak tersedia!');
            } else if (error.response.data.message) {
              setVoucherModalNewOpen(true);
              setVoucherModalNewIsSuccess(false);
              setVoucherModalNewMsgId('already-used-email');
              setVoucherModalNewTitle('Voucher Sudah digunakan!');
              setVoucherModalNewMsgOtherEmail(error.response.data.message);
            }
          } else if (error.response.status === '400') {
            if (error.response.data.message === 'You are Already enrolled in this course') {
              setVoucherModalNewOpen(true);
              setVoucherModalNewIsSuccess(false);
              setVoucherModalNewMsgId('course-owned');
              setVoucherModalNewTitle('Anda sudah memiliki Kelas ini.');
            } else if (error.response.data.message) {
              setVoucherModalNewOpen(true);
              setVoucherModalNewIsSuccess(false);
              setVoucherModalNewMsgId('already-used-email');
              setVoucherModalNewTitle('Voucher Sudah digunakan!');
              setVoucherModalNewMsgOtherEmail(error.response.data.message);
            }
          } else {
            NotificationManager.error('Some Error Occured in API!', 'Validasi Error!');
          }
        } else {
          NotificationManager.error('Some Error Occured in API!', 'Validasi Error!');
        }
      });
  };

  return (
    <>
      {!smallBanner ? (
        ''
      ) : (
        <Search
          checkValidVoucher={checkValidVoucher}
          handleVoucherChange={(e) => setVoucher_code(e.target.value)}
          voucherCode={voucher_code}
        />
      )}

      <VoucherModals
        isModalOpen={voucherModalNewOpen}
        closeModal={() => setVoucherModalNewOpen(false)}
        title={voucherModalNewTitle}
        isSuccess={voucherModalNewIsSuccess}
        msgId={voucherModalNewMsgId}
        usedByOther={voucherModalNewMsgOtherEmail}
        refreshInsted={secondaryStyle ? true : false}
      />
      <VoucherPopup
        isOpen={voucherModalOpen}
        toggleModalVoucherPage={toggleModalVoucherPage}
        toggleFinalSubmitPage={toggleFinalSubmitPage}
      />

      <VoucherFinalPurchase
        isOpen={voucherFinalSubmitModalOpen}
        toggleModalVoucherPage={toggleModalVoucherPurchasePage}
        voucher_code_referral={voucher_code_referral}
      />
      <NotificationContainer />
      {alert}
    </>
  );
};

export default LandingBannerNew;
